import React, { Fragment, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'

import { AiOutlineUser } from 'react-icons/ai'
import { RxEyeClosed, RxEyeOpen } from 'react-icons/rx'
import { BsCreditCard2Back, BsWallet2 } from 'react-icons/bs'
import { GoNote } from 'react-icons/go'
import { IoCarSportOutline, IoBusinessOutline } from 'react-icons/io5'
import { GiChart } from 'react-icons/gi'
import { HiOutlineHomeModern } from 'react-icons/hi2'
import { MdOutlineSavings, MdOutlineBusinessCenter } from 'react-icons/md'

import Footer from '../Components/Footer'

import '../Styles/Login.css'

import slide from '../Contents/images/utils/car.png'
import { useStateValue } from '../Utils/StateProvider'
import { useCookies } from 'react-cookie'

function Login() {
    const [cookies, setCookie] = useCookies(['bearerToken', 'username', 'alive', 'uid']);
    const [{ url }, payload] = useStateValue()
    const [submitBtnStatus, setSubmitBtnStatus] = useState('button')
    const [submitBtnText, setSubmitBtnText] = useState('Enter Valid Credentials')
    const [validateBtnStatus, setValidateBtnStatus] = useState('button')
    const [viewPass, setViewPass] = useState(false)
    const [rememberMe, setRememberMe] = useState(false)
    const [extraCheck, setExtraCheck] = useState(false)
    const [authData, setAuthData] = useState({})
    const [error, setError] = useState(null)

    const navigate = useNavigate()

    const handleLogIn = async (e) => {
        e.preventDefault()
        setError(null)
        payload({type: 'TOGGLE_PROCESSING', state: true})
        try {
            if (rememberMe && authData.username) setCookie('username', authData.username)

            const response = await axios.post(`${url}/api/u/auth`, authData)
            const cd = response.data.data.user
            const token = response.data.data.token

            const suspense_message = `We've noticed some suspicious transacting on this account and have place this account on a temporary suspension pending further authentication. Please contact support for further assistance.`
            if (parseInt(cd.flag_on_log) > 0 || parseInt(cd.suspend) > 0) {
                try {
                    await axios.patch(`${url}/api/u`, {
                        setters: {
                            suspend: 1
                        },
                        validators: {
                            uid: cd.uid
                        }
                    },  {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                } catch(err) {
                    console.error(err.response.data.message)
                } finally {
                    return payload({
                        type: 'SET_NOTIFY',
                        data: {
                            text: suspense_message,
                            type: 'error'
                        }
                    })
                }
            }
            if (parseInt(cd.block) > 0) return setError(`This account has been blocked. Please contact support for further assistance.`)

            setCookie('uid', cd.uid, { path: '/', expires: new Date(new Date().getTime() + (1000 * 60 * 60 * 24) ) })
            setCookie('alive', 1, { path: '/', expires: new Date(new Date().getTime() + (1000 * 60 * 60) ) })
            setCookie('bearerToken', token, { path: '/', expires: new Date(new Date().getTime() + (1000 * 60 * 60) ) })
        }catch (err) {
            setError(err.response.data.message)
        }finally {
            payload({type: 'TOGGLE_PROCESSING', state: false})
        }
    }

    useEffect(() => {
        if (cookies.username) {
            setRememberMe(true)
            setAuthData({...authData, username: cookies.username})
        }
    }, [cookies])

    useEffect(() => {
        if (
            (authData.username && authData.username.length >= 6) &&
            (authData.password && authData.password.length >= 6)
        ) {
            setSubmitBtnStatus('submit')
            setSubmitBtnText('Gain Access')
        }else {
            setSubmitBtnStatus('button')
            setSubmitBtnText('Enter Valid Credentials')
        }
        setError(null)
    }, [authData])

    return (
        cookies.bearerToken && 
        ![undefined, 'undefined', null, 'null'].includes(cookies.bearerToken) &&
        cookies.alive && parseInt(cookies.alive) === 1 ? (
            navigate('/dashboard')
        ) : (
            <Fragment>
                <main  className='login'>
                    <div className="container full-width form-column-parent">
                        <div className="row">
                            <div className="column-container">
                                <div className="column">
                                    <form onSubmit={handleLogIn}>
                                        {
                                            error && (
                                                <div className='log-error-box'>{error}</div>
                                            )
                                        }
                                        {
                                            !extraCheck ? (
                                                <div className="form-pt-one">
                                                    <div className="form-row input-row">
                                                        <input 
                                                            type="text" 
                                                            name='username' 
                                                            id='username' 
                                                            value={authData.username}
                                                            onChange={e => setAuthData({...authData, username: e.target.value})}
                                                            required 
                                                        />
                                                        <label htmlFor="username">User ID</label>
                                                        <AiOutlineUser />
                                                    </div>
                                                    <div className="form-row input-row password-row">
                                                        <input 
                                                            type={viewPass ? "text" : "password" } 
                                                            name='password' 
                                                            id='password'
                                                            value={authData.password}
                                                            onChange={e => setAuthData({...authData, password: e.target.value})} 
                                                            required 
                                                        />
                                                        <label htmlFor="password">Passphrase</label>
                                                        {
                                                            viewPass ? (
                                                                <RxEyeOpen onClick={() => setViewPass(false)} />
                                                            ) : (
                                                                <RxEyeClosed onClick={() => setViewPass(true)} />
                                                            )
                                                        }
                                                    </div>
                                                    <div className="form-row check-box">
                                                        <input 
                                                            type="checkbox" 
                                                            name='remember'
                                                            checked={rememberMe}
                                                            onChange={() => setRememberMe(!rememberMe)}
                                                            id='remember' 
                                                        />
                                                        <label htmlFor="remember">Remember me</label>
                                                    </div>
                                                    <div className="form-row button-row">
                                                        <button type={submitBtnStatus}>{submitBtnText}</button>
                                                    </div>
                                                    <div className="form-row link-row">
                                                        <Link to='/reset'>Forgot User ID/Passphrase?</Link>
                                                        <Link to='/enroll'>Not enrolled yet? Join us today.</Link>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="form-pt-two hide">
                                                    <div className="form-row input-row">
                                                        <input 
                                                            type="text" 
                                                            name='pass-code' 
                                                            id='pass-code' 
                                                            value={authData.pass_code}
                                                            onChange={e => setAuthData({...authData, pass_code: e.target.value})}
                                                            required 
                                                        />
                                                        <label htmlFor="pass-code">Pass Code</label>
                                                    </div>
                                                    <div className="form-row button-row">
                                                        <button type={validateBtnStatus}>Validate</button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </form>
                                </div>
                                <div className="column">
                                    <article>
                                        <p><span className='secondary-color' style={{fontSize: 58}}>Join</span> our team and experience the power of smart finance. <Link to='/reg/savings-account'><span style={{fontSize: 12}}>Get Started Today.</span></Link></p>
                                    </article>
                                    <img src={slide} alt="" width={650} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <h1>Get introduced to whole new world of <span className='secondary-color'>Banking</span>.</h1>
                            <h4>sign in to get started</h4>
                            <hr />
                            <div className="tools">
                                <h3>Tools:</h3>
                                <ul>
                                    <Link to='/reset'>
                                        <li>
                                            <BsCreditCard2Back />
                                            <span>Credit Cards</span>
                                        </li>
                                    </Link>
                                    <Link to='/'>
                                        <li>
                                            <GoNote />
                                            <span>Checking Account</span>
                                        </li>
                                    </Link>
                                    <Link to=''>
                                        <li>
                                            <MdOutlineSavings />
                                            <span>Savings Account</span>
                                        </li>
                                    </Link>
                                    <Link to='/'>
                                        <li>
                                            <BsWallet2 />
                                            <span>CDs</span>
                                        </li>
                                    </Link>
                                    <Link to='/'>
                                        <li>
                                            <IoCarSportOutline />
                                            <span>Auto Loans</span>
                                        </li>
                                    </Link>
                                    <Link to='/'>
                                        <li>
                                            <HiOutlineHomeModern />
                                            <span>Mortgage & Home Equity</span>
                                        </li>
                                    </Link>
                                    <Link to='/'>
                                        <li>
                                            <GiChart />
                                            <span>Investing</span>
                                        </li>
                                    </Link>
                                    <Link to='/'>
                                        <li>
                                            <MdOutlineBusinessCenter />
                                            <span>Business</span>
                                        </li>
                                    </Link>
                                    <Link to='/'>
                                        <li>
                                            <IoBusinessOutline />
                                            <span>Commercial Banking</span>
                                        </li>
                                    </Link>
                                </ul>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </Fragment>
        )
    )
}

export default Login
